import { useAuth0 } from '@auth0/auth0-react'
import { Box, Typography, CircularProgress } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'

const Logout = (): JSX.Element => {
  const { logout } = useAuth0()

  logout({ logoutParams: { returnTo: window.location.origin } })

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #F0F4F8 0%, #E0F7FA 50%, #F0F4F8 100%)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          p: 5,
          borderRadius: 4,
          bgcolor: 'white',
          boxShadow: '0 8px 32px rgba(0, 124, 145, 0.12)',
          border: '1px solid rgba(0, 124, 145, 0.08)',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #546E7A 0%, #78909C 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 16px rgba(84, 110, 122, 0.3)',
          }}
        >
          <LogoutIcon sx={{ fontSize: 30, color: 'white' }} />
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#263238', mb: 0.5 }}>
            Logging Out
          </Typography>
          <Typography variant="body2" sx={{ color: '#78909C' }}>
            You are being signed out securely…
          </Typography>
        </Box>
        <CircularProgress size={28} sx={{ color: '#78909C' }} />
      </Box>
    </Box>
  )
}

export default Logout
